import { Button } from "@mui/material";
import ActivateIcon from "@mui/icons-material/CheckCircleOutline";
import { LoadingButton } from "@mui/lab";
import { useRecordContext } from "react-admin";
import { Student } from "../providers/studentsProvider";
import { MouseEvent, useState } from "react";
import { setStudentStatus } from "../api/backoffice.api";
import { grants } from "../backoffice.access_control";

export function ActivateStudentButton({ variant = "rowButton" }: { variant?: "rowButton" | "dialogButton" }) {
  const student = useRecordContext<Student>();
  const [loading, setLoading] = useState(false);
  const activateStudent = async (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (student.status === "completed") {
      showErrorToast("Ein Fahrschüler, der alle Fahrprüfungen bestanden hat, kann nicht aktiviert werden.");
      return;
    }
    if (student.status === "outstandingPayments" && !grants.has("changeStatusOfStudentWithOutstandingPayments")) {
      showErrorToast("Du bist nicht berechtigt, einen Fahrschüler mit ausstehenden Zahlungen zu aktivieren.");
      return;
    }
    setLoading(true);
    await runSafely(() => setStudentStatus(student, "active", /* reason */ ""), {
      successMessage: `${student.callName} erfolgreich aktiviert.`,
      errorMessage: `Fehler beim Aktivieren von ${student.callName}.`,
    });
    setLoading(false);
  };
  return variant === "rowButton" ? (
    <LoadingButton
      startIcon={<ActivateIcon />}
      variant="outlined"
      loading={loading}
      disabled={!student}
      onClick={activateStudent}
    >
      Aktivieren
    </LoadingButton>
  ) : (
    <Button variant="text" disableRipple sx={{ height: "20px" }} onClick={activateStudent}>
      Aktivieren
    </Button>
  );
}
